import React, { useState, useEffect, useRef } from 'react';
import RemindIcon from '@rsuite/icons/legacy/Remind';
import TrashIcon from '@rsuite/icons/Trash';
import CheckIcon from '@rsuite/icons/Check';
import EditIcon from '@rsuite/icons/Edit';
import CloseIcon from '@rsuite/icons/Close';
import EyeIcon from '@rsuite/icons/legacy/Eye';
import EyeSlashIcon from '@rsuite/icons/legacy/EyeSlash';
import globalIP from '../../GlobelIP';
import LoadingBar from 'react-top-loading-bar';
import Upload from './upload.jpg';
import ImageIcon from '@rsuite/icons/Image';
import UserExpiryEditor from './expiryTime'
import {
  Input,
  InputGroup,
  Table,
  Button,
  IconButton,
  InputPicker,
  Stack,
  Breadcrumb,
  Divider,
  Modal,
  Col,
  Form,
  FlexboxGrid,
  Container,
  SelectPicker,
  Uploader,
  useToaster,
  Message,
  Schema,
  InputNumber,
  Whisper,
  Tooltip,
  Dropdown
} from 'rsuite';
import SearchIcon from '@rsuite/icons/Search';
import { Link } from 'react-router-dom';
import axios from 'axios';
import YourModal from './Modal';
import { validateEmail2 } from '@/functions';
import ugr from '@/UGRoute';
import { Check, Close, ReviewPass, UserBadge, UserChange } from '@rsuite/icons';
import { Popconfirm, Select, Switch } from 'antd';
import { getDeviceId } from '@/utils/fingerPrint';
import { RefreshCcw, Users } from 'lucide-react';
import AccessEditor from './outsideAcess';
const { Option } = Select;

const styles = {
  width: 'auto',
  size: 'xs'
};
interface RowData {
  id: string; // or number, depending on your data
  attributes: {
    Company_Name: string;
    Full_Name: string;
    Username: string;
    Category: string;
    Email_Id: string;
    Made_By: string;
    MobileNo: string;
    Password: string;
    Designation: string;
    // Add other attributes if needed
  };
}
interface PaginationData {
  page: number;
  pageSize: number;
  pageCount: number;
  total: number;
}
interface MetaData {
  pagination: PaginationData;
}
const { Column, HeaderCell, Cell } = Table;

const Category = ['Admin', 'Staff'].map(item => ({ label: item, value: item }));

const { StringType } = Schema.Types;

const model = Schema.Model({
  password: StringType().isRequired('This field is required.'),
  verifyPassword: StringType()
    .addRule((value, data) => {
      if (value !== data.password) {
        return false;
      }

      return true;
    }, 'The passwords do not match')
    .isRequired('This field is required.')
});

const TextField = React.forwardRef((props, ref) => {
  const { name, label, accepter, ...rest } = props;
  return (
    <Form.Group controlId={`${name}-4`} ref={ref}>
      <Form.ControlLabel>{label} </Form.ControlLabel>
      <Form.Control name={name} accepter={accepter} {...rest} />
    </Form.Group>
  );
});

const AddUser = () => {
  const ipp = globalIP;
  const formRef = React.useRef();
  const [formValue, setFormValue] = useState({
    password: '',
    verifyPassword: ''
  });
  const [auth, setAuth] = useState(false);
  const [data1, setData1] = React.useState([]);
  useEffect(() => {
    fetchDatac();
  }, []);
  const fetchDatac = async () => {
    try {
      const response = await fetch(`${ip}/api/company-details?populate=*`);
      const json = await response.json();
      const processedData = json.data.map(item => ({
        label: item.attributes.cmpnm,
        value: item.attributes.cmpcd
      }));
      setData1(processedData);
      setAuth(json.data[0].attributes.Authorised);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };

  // POST Data from API Start
  const [data, setData] = useState<RowData[]>([]);
  const [dataadd, setDataadd] = useState({
    Company_Name: '',
    Full_Name: '',
    Username: '',
    Category: '',
    Email_Id: '',
    Made_By: 'Shantanu',
    MobileNo: '0',
    Password: '',
    Designation: '',
    UserCode: ''
  });
  const generateNextUserCode = () => {
    const nextCode = meta?.pagination?.total + 1;
    return `USR-${nextCode.toString().padStart(3, '0')}`;
  };
  let nextUserCode = generateNextUserCode();
  const submit = async e => {
    const { data: userData } = await axios.get(
      `${ipp}/api/user-details?populate=*&filters[Username][$eqi]=${dataadd.Username}`
    );
    const usernameExists = userData.data.some(
      user => user.attributes.Username.toLowerCase() === dataadd.Username.toLowerCase()
    );
    if (dataadd.Full_Name.trim() === '') {
      toaster.push(
        <Message showIcon type="error">
          Enter Full Name
        </Message>,
        { placement: 'topCenter' }
      );
      return;
    } else if (dataadd.Category === '' || dataadd.Category === null) {
      toaster.push(
        <Message showIcon type="error">
          Enter Category
        </Message>,
        { placement: 'topCenter' }
      );
      return;
    } else if (dataadd.Username.trim() === '') {
      toaster.push(
        <Message showIcon type="error">
          Enter Username
        </Message>,
        { placement: 'topCenter' }
      );
      return;
    } else if (usernameExists) {
      toaster.push(
        <Message showIcon type="error">
          Username already taken. Please choose a different one.
        </Message>,
        { placement: 'topCenter' }
      );
      return;
    } else if (dataadd.Password.trim() === '') {
      toaster.push(
        <Message showIcon type="error">
          Enter Password
        </Message>,
        { placement: 'topCenter' }
      );
      return;
    } else if (dataadd.Password !== formValue.verifyPassword) {
      toaster.push(
        <Message showIcon type="error">
          Please Confirm Password
        </Message>,
        { placement: 'topCenter' }
      );
      return;
    } else if (dataadd.Company_Name === '') {
      toaster.push(
        <Message showIcon type="error">
          Enter Company Name
        </Message>,
        { placement: 'topCenter' }
      );
      return;
    }

    if (dataadd.Email_Id) {
      if (dataadd.Email_Id.trim() == '') {
        toaster.push(
          <Message showIcon type="error">
            Email is required
          </Message>,
          { placement: 'topCenter' }
        );
        return;
      } else if (!validateEmail2(dataadd.Email_Id.trim())) {
        toaster.push(
          <Message showIcon type="error">
            Please check our Email.
          </Message>,
          { placement: 'topCenter' }
        );
        return;
      }
    }
    e.preventDefault();
    nextUserCode = generateNextUserCode();
    const nextCUCode = nextUserCode;
    const formData = new FormData();
    formData.append('files.UserImage', dataadd.UserImage);
    const condition = dataadd.Category === 'Admin' ? true : false;
    let authorizedStatus;
    if (!auth) {
      authorizedStatus = true;
    } else {
      authorizedStatus = dataadd.Category === 'Admin' ? true : false;
    }
    formData.append(
      'data',
      JSON.stringify({
        ...dataadd,
        UserCode: nextCUCode,
        MProduct: condition,
        MCatalogue: condition,
        MCollection: condition,
        MQuotation: condition,
        MBuyer: condition,
        MEmarketing: condition,
        PMaster: condition,
        MSTCategory: condition,
        MSTPType: condition,
        MSTCollection: condition,
        MSTFinish: condition,
        MSTColor: condition,
        MSTHSN: condition,
        MSTShape: condition,
        MSTPTechnique: condition,
        MSTProcess: condition,
        MSTMaterial: condition,
        PRDView: condition,
        PRDAdd: condition,
        PRDManage: condition,
        PRDEdit: condition,
        PRDDelete: condition,
        PRDpicdwnld: condition,
        CATcreate: condition,
        CATupdate: condition,
        CATaccessPPT: condition,
        CATLinkSecurity: condition,
        CATShwPrice: condition,
        CATCustomizeTab: condition,
        CATModifySts: condition,
        CATBuyerAct: condition,
        CATControlSet: condition,
        CATDelete: condition,
        MSpaceV: condition,
        MFair: condition,
        MEnquiry: condition,
        Authorised: authorizedStatus
      })
    );

    fetch(`${ipp}/api/user-details`, {
      method: 'POST',
      body: formData
    })
      // .then(response => fetchData())
      .then(Response => Response.json())
      .then(data => {
        // console.log(data);
        fetchData();
      })
      .catch(error => console.error(error));
    toaster.push(message, { placement: 'topCenter' });
    setDataadd({
      Company_Name: '',
      Full_Name: ' ',
      Username: '',
      Category: '',
      Email_Id: '',
      Made_By: 'Shantanu',
      MobileNo: '0',
      Password: '',
      Designation: '',
      UserCode: ''
    });

    setFormValue({
      verifyPassword: ''
    });
    handleClose();
    setImageFile(null);
  };

  // POST Data from API End

  const toaster = useToaster();
  const message = (
    <Message showIcon type="success" closable>
      Saved Successfully
    </Message>
  );

  const handleInputChange = (inputName, value) => {
    setDataadd(prevData => ({
      ...prevData,
      [inputName]:
        inputName === 'MobileNo'
          ? value?.toString().trim() || '0' // Default to '0' if empty
          : inputName === 'Username'
            ? value.trim()
            : value !== null
              ? value
              : ''
    }));
  };

  const fileInputRef = useRef(null);

  const handleButtonClick = () => {
    fileInputRef.current.click();
  };
  const handleFileChange = event => {
    const file = event.target.files[0];
    // console.log('file :', file);

    if (file) {
      // Validate the file type
      const validTypes = ['image/jpeg', 'image/jpg'];
      if (!validTypes.includes(file.type)) {
        alert('Please upload a file in JPG or JPEG format.');
        return;
      }
      // Create a blob URL
      const blobFile = URL.createObjectURL(file);
      setImageFile(blobFile);
      // console.log('blob file : ', blobFile);

      // Call the handleImageUpload function
      handleImageUpload([{ file }]);
    }
  };
  const handleImageUpload = async fileList => {
    // console.log('blob file : ', fileList);
    setDataadd({
      ...dataadd,
      UserImage: fileList[0].file
    });
  };

  // Fetch Data from API Start

  const [meta, setMeta] = useState<MetaData>();
  const [editedRowIds, setEditedRowIds] = useState<string[]>([]);
  const [editedData, setEditedData] = useState<Record<string, Partial<RowData['attributes']>>>({});
  const [progress, setProgress] = useState(0);
  const [isUserDiscontinue, setIsUserDiscontinue] = useState(false);

  const handleUserActiveChange = value => {
    // AntD Select sometimes gives string values if not coerced
    setIsUserDiscontinue(value === true || value === 'true');
  };

  useEffect(() => {
    fetchData();
  }, [isUserDiscontinue]);
  const fetchData = async () => {
    setProgress(30);
    let filterQuery = '';

    if (isUserDiscontinue) {
      // 🔹 Only discontinued users (true)
      filterQuery = 'filters[isUserDiscontinue][$eq]=true';
    } else {
      // 🔹 Active = false OR null
      filterQuery =
        'filters[$or][0][isUserDiscontinue][$eq]=false&filters[$or][1][isUserDiscontinue][$null]=true';
    }
    const response = await fetch(
      `${ip}/api/user-details?populate=*&${filterQuery}&pagination[page]=1&sort[0]=id:desc`
    );
    setProgress(40);
    const json = await response.json();
    const allData = [];
    for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
      const pageResponse = await fetch(
        `${ip}/api/user-details?populate=*&${filterQuery}&pagination[page]=${page}&sort[0]=id`
      );
      const pageJson = await pageResponse.json();
      allData.push(...pageJson.data);
    }
    setProgress(80);
    setData(allData);
    setMeta(json.meta);
    setProgress(100);
  };
  //  Fetch Data from API End
  const handleEditRow = rowData => {
    setEditedRowIds(prevRowIds => [...prevRowIds, rowData.id]);
    setEditedData(prevData => ({
      ...prevData,
      [rowData.id]: { ...rowData.attributes }
    }));
  };

  const [userImageId, setUserImageId] = useState();

  const handleSaveRoww = async (rowId: string) => {
    try {
      const editedUser = editedData[rowId]?.Username.trim().toLowerCase();
      // console.log('Checking for existing username:', editedUser);

      const { data: updateUsernameData } = await axios.get(
        `${ip}/api/user-details?filters[Username][$eqi]=${editedUser}`
      );

      // console.log('API Response for existing usernames:', updateUsernameData.data);

      const updatedUsernameExists = updateUsernameData.data.some((user: any) => user.id !== rowId);

      // console.log('Username conflict:', updateUsernameData);

      if (updatedUsernameExists && updateUsernameData.data.length) {
        toaster.push(
          <Message showIcon type="error">
            Updated Username already exists.
          </Message>,
          { placement: 'topCenter' }
        );
        return;
      }

      const editedName = editedData[rowId]?.Full_Name;
      // const editedUser = editedData[rowId]?.Username;
      const editedPassword = editedData[rowId]?.Password;
      const editedCategory = editedData[rowId]?.Category;
      const editedcompany = editedData[rowId]?.Company_Name;
      const editedemail = editedData[rowId]?.Email_Id;
      const editedemobile = editedData[rowId]?.MobileNo;
      if (!editedName || editedName.trim() === '') {
        toaster.push(
          <Message showIcon type="error">
            Enter Name
          </Message>,
          { placement: 'topCenter' }
        );
        return;
      } else if (!editedUser || editedUser.trim() === '') {
        toaster.push(
          <Message showIcon type="error">
            Enter UserName
          </Message>,
          { placement: 'topCenter' }
        );
        return;
      }

      if (!editedPassword || editedPassword.trim() === '') {
        toaster.push(
          <Message showIcon type="error">
            Enter Password
          </Message>,
          { placement: 'topCenter' }
        );
        return;
      } else if (!editedCategory || editedCategory.trim() === '') {
        toaster.push(
          <Message showIcon type="error">
            Select Category
          </Message>,
          { placement: 'topCenter' }
        );
        return;
      } else if (!editedcompany || editedcompany.trim() === '') {
        toaster.push(
          <Message showIcon type="error">
            Select Company
          </Message>,
          { placement: 'topCenter' }
        );
        return;
      }

      if (editedemail) {
        if (editedemail.trim() == '') {
          toaster.push(
            <Message showIcon type="error">
              Email is required
            </Message>,
            { placement: 'topCenter' }
          );
          return;
        } else if (!validateEmail2(editedemail.trim())) {
          toaster.push(
            <Message showIcon type="error">
              Please check our Email.
            </Message>,
            { placement: 'topCenter' }
          );
          return;
        }
      }
      if (editedemobile) {
        if (editedemobile.trim() == '') {
          toaster.push(
            <Message showIcon type="error">
              Contact no is required.
            </Message>,
            { placement: 'topCenter' }
          );
          return;
        } else if (!(editedemobile.trim().length <= 12)) {
          toaster.push(
            <Message showIcon type="error">
              Please check our Contact no.
            </Message>,
            { placement: 'topCenter' }
          );
          return;
        }
      }
      const rowData = data.find(row => row.id === rowId);

      if (!rowData) {
        console.error('Row data not found.');
        return;
      }
      const updatedRowData = {
        ...rowData,
        attributes: editedData[rowId]
      };

      delete updatedRowData.attributes.UserImage;
      const formData = new FormData();
      if (imageFile) {
        if (userImageId) {
          const data = await axios.delete(`${ip}/api/upload/files/${userImageId}`);
          // console.log(data);
        }
        formData.append('files.UserImage', imageFile);
      }
      formData.append('data', JSON.stringify(updatedRowData.attributes));
      const response = await fetch(`${ip}/api/user-details/${rowData.id}`, {
        method: 'PUT',
        body: formData
      });
      if (response.ok) {
        fetchData();
        setImageFile(null);
        setEditedRowIds(prevRowIds => prevRowIds.filter(id => id !== rowId));
      } else {
        // Handle error if needed
        console.error('Failed to save data');
      }
    } catch (error) {
      console.error('Error occurred while saving data', error);
    }
  };
  const handleSaveRow = async (rowId: string) => {
    try {
      const editedUser = editedData[rowId]?.Username?.trim().toLowerCase(); // Make sure Username exists

      // Check if the Username exists and handle the case where it's undefined
      if (!editedUser) {
        toaster.push(
          <Message showIcon type="error">
            Username is required.
          </Message>,
          { placement: 'topCenter' }
        );
        return;
      }

      const { data: updateUsernameData } = await axios.get(
        `${ip}/api/user-details?filters[Username][$eqi]=${editedUser}&filters[id][$ne]=${rowId}`
      );

      // console.log('API Response for existing usernames:', updateUsernameData.data);

      if (updateUsernameData.data.length) {
        toaster.push(
          <Message showIcon type="error">
            Updated Username already exists.
          </Message>,
          { placement: 'topCenter' }
        );
        return;
      }

      const editedName = editedData[rowId]?.Full_Name;
      const editedPassword = editedData[rowId]?.Password;
      const editedCategory = editedData[rowId]?.Category;
      const editedcompany = editedData[rowId]?.Company_Name;
      const editedemail = editedData[rowId]?.Email_Id;
      const editedemobile = editedData[rowId]?.MobileNo;

      if (!editedName || editedName.trim() === '') {
        toaster.push(
          <Message showIcon type="error">
            Enter Name
          </Message>,
          { placement: 'topCenter' }
        );
      } else if (!editedUser || editedUser.trim() === '') {
        toaster.push(
          <Message showIcon type="error">
            Enter UserName
          </Message>,
          { placement: 'topCenter' }
        );
      } else if (!editedPassword || editedPassword.trim() === '') {
        toaster.push(
          <Message showIcon type="error">
            Enter Password
          </Message>,
          { placement: 'topCenter' }
        );
      } else if (!editedCategory || editedCategory.trim() === '') {
        toaster.push(
          <Message showIcon type="error">
            Select Category
          </Message>,
          { placement: 'topCenter' }
        );
      } else if (!editedcompany || editedcompany.trim() === '') {
        toaster.push(
          <Message showIcon type="error">
            Select Company
          </Message>,
          { placement: 'topCenter' }
        );
      } else if (editedemail && editedemail.trim() === '') {
        toaster.push(
          <Message showIcon type="error">
            Email is required
          </Message>,
          { placement: 'topCenter' }
        );
      } else if (editedemail && !validateEmail2(editedemail.trim())) {
        toaster.push(
          <Message showIcon type="error">
            Please check our Email.
          </Message>,
          { placement: 'topCenter' }
        );
      } else if (editedemobile && editedemobile.trim() === '') {
        toaster.push(
          <Message showIcon type="error">
            Contact no is required.
          </Message>,
          { placement: 'topCenter' }
        );
      } else if (editedemobile && !(editedemobile.trim().length <= 12)) {
        toaster.push(
          <Message showIcon type="error">
            Please check our Contact no.
          </Message>,
          { placement: 'topCenter' }
        );
      } else {
        const rowData = data.find(row => row.id === rowId);
        if (!rowData) {
          console.error('Row data not found.');
          return;
        }
        let authorizedStatus;
        if (!auth) {
          authorizedStatus = true;
        } else {
          authorizedStatus = rowData.attributes.Category === 'Admin' ? true : false;
        }
        // console.log('authorizedStatus');
        // console.log(authorizedStatus);
        const updatedRowData = {
          ...rowData,
          attributes: { ...editedData[rowId], Authorised: authorizedStatus },
        };

        delete updatedRowData.attributes.UserImage;

        const formData = new FormData();
        if (imageFile) {
          if (userImageId) {
            const data = await axios.delete(`${ip}/api/upload/files/${userImageId}`);
            console.log(data);
          }
          formData.append('files.UserImage', imageFile);
        }
        formData.append('data', JSON.stringify(updatedRowData.attributes,));

        // Perform PUT request after all validations pass
        const response = await fetch(`${ip}/api/user-details/${rowData.id}`, {
          method: 'PUT',
          body: formData
        });

        if (response.ok) {
          fetchData();
          setImageFile(null);
          setEditedRowIds(prevRowIds => prevRowIds.filter(id => id !== rowId));
        } else {
          console.error('Failed to save data');
        }
      }
    } catch (error) {
      console.error('Error occurred while saving data', error);
    }
  };

  const [imageFile, setImageFile] = useState(null);

  const handleInputChangeadduser = (rowId, fieldName, value) => {
    if (fieldName === 'UserImage') {
      setImageFile(value);
    } else {
      setEditedData(prevData => {
        const updatedData = { ...prevData };
        if (!updatedData[rowId]) {
          updatedData[rowId] = { ...data.find(row => row.id === rowId).attributes };
        }
        // Ensure MobileNo is never blank
        updatedData[rowId][fieldName] =
          fieldName === 'MobileNo'
            ? value?.toString().trim() || '0' // Default to '0' if empty
            : fieldName === 'Username'
              ? value.trim()
              : value !== null
                ? value
                : '';
        return updatedData;
      });
    }
  };

  // Delete Data from API Start
  // const handleDeleteRow = async (rowId) => {
  //     try {
  //         const response = await fetch(`${ipp}/api/user-details/${rowId}`, {
  //             method: 'DELETE',
  //         });
  //         if (response.ok) {
  //             // Row deletion was successful, update your local data or refresh the table
  //             const updatedData = data.filter((row) => row.id !== rowId);
  //             setData(updatedData);
  //             console.log('Row deleted successfully.');
  //         } else {
  //             console.log('Failed to delete row.');
  //         }
  //     } catch (error) {
  //         console.error('Error deleting row:', error);
  //     }
  // };
  // Fetch Data from API End

  const ip = ipp;

  // for from
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setDataadd({
      Company_Name: '',
      Full_Name: ' ',
      Username: '',
      Category: '',
      Email_Id: '',
      Made_By: 'Shantanu',
      MobileNo: '0',
      Password: '',
      Designation: '',
      UserCode: '',
      UserImage: null
    });

    setFormValue({
      verifyPassword: ''
    });
    setOpen(false);
  };

  // for alert
  const [open1, setOpen1] = React.useState(false);
  const handleOpen1 = () => setOpen1(true);
  const handleClose1 = () => setOpen1(false);

  const [searchQuery, setSearchQuery] = useState('');

  const handleSearch = value => {
    setSearchQuery(value);
  };

  useEffect(() => {
    const handleSearch = async () => {
      // const { data: usersData } = await axios.get(`${ipp}/api/user-details?populate=*&filters[Username][$startsWithi]=${searchQuery}`)
      const { data: usersData } = await axios.get(
        `${ipp}/api/user-details?populate=*&filters[$or][0][Username][$startsWithi]=${searchQuery}&filters[$or][1][Full_Name][$startsWithi]=${searchQuery}&filters[$or][2][Company_Name][$startsWithi]=${searchQuery}&filters[$or][3][MobileNo][$startsWithi]=${searchQuery}&filters[$or][4][Category][$startsWithi]=${searchQuery}&filters[$or][5][Email_Id][$startsWithi]=${searchQuery}`
      );
      console.log(usersData, '<--- usersData');

      setData(usersData.data);
    };

    if (searchQuery !== '') {
      handleSearch();
    } else {
      fetchData();
    }
  }, [searchQuery]);

  const [companydataa, setCompanydataa] = React.useState([]);
  useEffect(() => {
    fetchData6();
  }, []);
  const fetchData6 = async () => {
    try {
      const response = await fetch(`${ip}/api/buyer-companies`);
      const json = await response.json();
      const processedData = json.data.map(item => ({
        label: item.attributes.companynm,
        value: item.attributes.companynm
      }));
      setCompanydataa(processedData);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };
  const [visible, setVisible] = React.useState(false);

  const handleChange = () => {
    setVisible(!visible);
  };
  const checkAliasCodeExistence = newProductId => {
    if (data.find(item => item.attributes.Username === newProductId)) {
      toaster.push(
        <Message showIcon type="error">
          Username already taken. Please change
        </Message>,
        { placement: 'topCenter' }
      );
    }
  };

  const [modalOpen, setModalOpen] = useState(false);
  const [modalData, setModalData] = useState(null);

  const handleModalOpen = id => {
    setModalData(id);
    setModalOpen(true);
  };

  const handleModalClose = () => {
    setModalOpen(false);
  };

  const CompactCell = props => <Cell {...props} style={{ padding: 6 }} />;
  const [tableHeight, setTableHeight] = useState(20); // Default height
  useEffect(() => {
    const calculateHeight = () => {
      const headerHeight = 250; // Adjust based on your header/footer size
      const footerHeight = 5; // Adjust based on your footer size
      const availableHeight = window.innerHeight - headerHeight - footerHeight;
      setTableHeight(availableHeight);
    };
    calculateHeight();
    window.addEventListener('resize', calculateHeight); // Recalculate on window resize
    return () => window.removeEventListener('resize', calculateHeight);
  }, []);
  const [desgindata, setDesgindata] = useState([]);
  useEffect(() => {
    fetchDataDesign();
  }, []);
  const fetchDataDesign = async () => {
    try {
      const response = await fetch(`${ip}/api/designations?&pagination[page]=1`);
      setProgress(60);
      const json = await response.json();
      const allData = [];
      for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
        const pageResponse = await fetch(`${ip}/api/designations?&pagination[page]=${page}`);
        const pageJson = await pageResponse.json();
        const processedData = pageJson.data.map(item => ({
          label: item.attributes.Designation,
          value: item.attributes.Designation
        }));
        allData.push(...processedData);
      }
      setDesgindata(allData);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };
  const handleDiscontinueUser = async (rowId, isDiscontinue = false) => {
    try {
      const rowData = data.find(row => row.id === rowId);
      if (!rowData) {
        toaster.push(
          <Message showIcon type="error">
            User data not found.
          </Message>,
          { placement: 'topCenter' }
        );
        return;
      }

      const updatedAttributes = {
        isUserDiscontinue: isDiscontinue
      };

      const formData = new FormData();
      formData.append('data', JSON.stringify(updatedAttributes));

      const response = await fetch(`${ip}/api/user-details/${rowId}`, {
        method: 'PUT',
        body: formData
      });

      if (response.ok) {
        toaster.push(
          <Message showIcon type="success">
            User has been {isDiscontinue ? 'discontinued' : 'reactivated'} successfully.
          </Message>,
          { placement: 'topCenter' }
        );
        fetchData();
      } else {
        toaster.push(
          <Message showIcon type="error">
            Failed to update user status.
          </Message>,
          { placement: 'topCenter' }
        );
      }
    } catch (error) {
      console.error('Error discontinuing user:', error);
      toaster.push(
        <Message showIcon type="error">
          Something went wrong while updating user status.
        </Message>,
        { placement: 'topCenter' }
      );
    }
  };

  const confirm = async (id, isDiscontinue) => {
    await handleDiscontinueUser(id, isDiscontinue)
  };
  const cancel = e => {
    console.log("User not discontinued")
  };
  const handleDeviceAction = async (rowData, deviceId, action) => {
    try {
      const apiURL =
        action === "approve"
          ? `${globalIP}/api/device-access/${deviceId}/approve`
          : `${globalIP}/api/device-access/${deviceId}/reject`;

      const response = await fetch(apiURL, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ userId: rowData.id })

      });

      const resData = await response.json();

      if (!response.ok) {
        toaster.push(
          <Message showIcon type="error">
            {resData?.error?.message || "Action failed"}
          </Message>,
          { placement: "topCenter" }
        );
        return;
      }

      toaster.push(
        <Message showIcon type="success">
          Device {action === "approve" ? "approved" : "rejected"} successfully
        </Message>,
        { placement: "topCenter" }
      );

      await fetchData();
    } catch (error) {
      console.error(error);
      toaster.push(
        <Message showIcon type="error">Something went wrong</Message>,
        { placement: "topCenter" }
      );
    }
  };

  const handleMultiDeviceAction = async (userId) => {
    try {
      const deviceRes = await fetch(`${globalIP}/api/device-access/user/${userId}`);
      const deviceData = await deviceRes.json();

      const devices = deviceData.devices || [];

      if (devices.length === 0) {
        toaster.push(
          <Message showIcon type="error">No device found for this user</Message>,
          { placement: "topCenter" }
        );
        return;
      }

      // 2️⃣ Get current deviceId of this device (from frontend function)
      const currentDeviceId = await getDeviceId();
      console.log("Current Device:", currentDeviceId);

      // 3️⃣ Match device row with this deviceId
      const matched = devices.find(d => d.deviceId === currentDeviceId);

      if (!matched) {
        toaster.push(
          <Message showIcon type="error">
            This device is not registered under this user
          </Message>,
          { placement: "topCenter" }
        );
        return;
      }
      const rowId = matched.id; // strapi row id
      const apiURL = `${globalIP}/api/device-access/${rowId}/allow-multiple-devices`;

      const response = await fetch(apiURL, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ allow: true })
      });

      const resData = await response.json();

      if (!response.ok) {
        toaster.push(
          <Message showIcon type="error">
            {resData?.error?.message || "Action failed"}
          </Message>,
          { placement: "topCenter" }
        );
        return;
      }

      toaster.push(
        <Message showIcon type="success">
          {resData.message}
        </Message>,
        { placement: "topCenter" }
      );

      fetchData(); // refresh table
    } catch (error) {
      console.error(error);
      toaster.push(
        <Message showIcon type="error">Something went wrong</Message>,
        { placement: "topCenter" }
      );
    }
  };
  const actionOptions = [
    { label: 'Approve', value: 'approve', icon: <Check /> },
    { label: 'Reject', value: 'reject', icon: <Close /> },
    // { label: 'Allow Multi', value: 'allow-multi', icon: <UserBadge /> }
  ];
  const [isRefreshing, setIsRefreshing] = useState(false);

  const handleRefresh = async () => {
    setIsRefreshing(true);

    await fetchData();        // your API call here

    setTimeout(() => setIsRefreshing(false), 700); // smooth stop delay
  };
  const [rowDevices, setRowDevices] = useState({}); // { [rowId]: { devices: [], selectedDevice: null } }
  useEffect(() => {
    data.forEach(row => loadDevicesForRow(row.id));
  }, [data]);
  const loadDevicesForRow = async (rowId) => {
    try {
      const res = await fetch(`${globalIP}/api/device-access/user/${rowId}`);
      const data = await res.json();
      const devices = data.devices || [];
      setRowDevices(prev => ({
        ...prev,
        [rowId]: {
          devices,
          selectedDevice: devices[0] || null
        }
      }));
    } catch (err) {
      console.error(err);
    }
  };
  const AllowMultipleToggle = ({ userId, initialValue }) => {
    const [checked, setChecked] = useState(initialValue);
    const [loading, setLoading] = useState(false);

    const handleToggle = async (checked) => {
      setLoading(true);
      try {
        const response = await fetch(`${globalIP}/api/user/allow-multiple-devices`, {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ userId: userId, allow: checked })
        });

        const data = await response.json();
        if (!response.ok) throw new Error(data?.error?.message || "Failed");
        await fetchData()
        toaster.push(<Message showIcon type="success">{data.message}</Message>, { placement: "topCenter" });
      } catch (err) {
        toaster.push(<Message showIcon type="error">{err.message}</Message>, { placement: "topCenter" });
      } finally {
        setLoading(false);
      }
    };
    return (
      <Switch
        size="sm"
        checked={checked}
        loading={loading}
        onChange={handleToggle}
      />
    );
  };
  return (
    <>
      <LoadingBar color="#3498ff" progress={progress} onLoaderFinished={() => setProgress(0)} />
      <Container className="main">
        <Stack className="table-toolbar  selection-head" justifyContent="space-between">
          <Stack.Item alignSelf="flex-start">
            <Stack direction="column" alignItems="flex-start">
              <h3 className="title">User Details</h3>
              <Breadcrumb>
                <Breadcrumb.Item>
                  <Link to={`/${ugr}/dashboard`}>Home</Link>
                </Breadcrumb.Item>
                <Breadcrumb.Item active>User Details</Breadcrumb.Item>
              </Breadcrumb>
            </Stack>
          </Stack.Item>
          <Stack
            alignItems="flex-end"
            spacing={10}
          // className="com-adduser"
          // style={{ marginBottom: '-9px', marginTop: '18px' }}
          >
            <button
              onClick={handleRefresh}
              className="p-2 rounded-lg hover:bg-gray-100 transition"
              title="Refresh"
            >
              <RefreshCcw
                className={`h-5 w-5 transition-all duration-500 ${isRefreshing ? "animate-spin" : ""
                  }`}
              />
            </button>
            <Select
              value={isUserDiscontinue ? true : false}
              style={{ width: 180, height: "35px" }}
              onChange={handleUserActiveChange}
            >
              <Option value={false}>Active</Option>
              <Option value={true}>Discontinued</Option>
            </Select>

            <InputGroup inside>
              <Input placeholder="Search" type="text" value={searchQuery} onChange={handleSearch} />
              <InputGroup.Addon>
                <SearchIcon />
              </InputGroup.Addon>
            </InputGroup>
            <Button color="cyan" appearance="primary" onClick={handleOpen}>
              Add User
            </Button>
          </Stack>
        </Stack>
        <Divider
          style={{ marginTop: '-15px', marginBottom: '10px' }}
        // className="divide"
        />
        {/* <b>Total User : {meta?.pagination?.total}</b> */}
        <b>Total User : {data.length}</b>
        <Table
          rowHeight={60}
          cellBordered
          data={
            data
            //   .filter(item => {
            //   const fullname = item.attributes.Full_Name.toLowerCase();
            //   const companyname = item.attributes.Company_Name.toLowerCase();
            //   const ContNo = item.attributes.MobileNo;
            //   const username = item.attributes.Username.toLowerCase();
            //   const category = item.attributes.Category.toLowerCase();
            //   const email = item.attributes.Email_Id;
            //   return (
            //     fullname.includes(searchQuery.toLowerCase()) ||
            //     companyname.includes(searchQuery.toLowerCase()) ||
            //     username.includes(searchQuery.toLowerCase()) ||
            //     category.includes(searchQuery.toLowerCase()) ||
            //     email.includes(searchQuery) ||
            //     ContNo.includes(searchQuery)
            //   );
            // })
          }
          height={tableHeight}
          rowKey="id"
          bordered
        >
          <Table.Column width={60} align="center" fixed>
            <HeaderCell>
              <b style={{ fontSize: '14px' }}>Sr.No.</b>
            </HeaderCell>
            <Cell>{(_, rowIndex) => rowIndex + 1}</Cell>
          </Table.Column>

          <Table.Column width={300} align="center">
            <Table.HeaderCell>
              <b style={{ fontSize: '14px' }}>Company Name</b>
            </Table.HeaderCell>
            <Table.Cell>
              {rowData =>
                editedRowIds.includes(rowData.id) ? (
                  <SelectPicker
                    data={data1}
                    value={editedData[rowData.id]?.Company_Name || ''}
                    onChange={value => handleInputChangeadduser(rowData.id, 'Company_Name', value)}
                  />
                ) : (
                  data1.find(category => category.value === rowData.attributes.Company_Name)
                    ?.label || ''
                )
              }
            </Table.Cell>
          </Table.Column>

          <Table.Column width={80} align="center">
            <Table.HeaderCell>
              <b style={{ fontSize: '14px' }}>Image</b>
            </Table.HeaderCell>
            <Table.Cell>
              {rowData => {
                const userImage = rowData.attributes?.UserImage?.data?.attributes?.url || '';
                return editedRowIds.includes(rowData.id) ? (
                  <>
                    <div className="table-image">
                      {userImage ? (
                        <img
                          src={!imageFile ? `${ip}${userImage}` : URL.createObjectURL(imageFile)}
                          alt="Upload"
                          style={{ width: '100%', zIndex: '10000' }}
                        />
                      ) : (
                        <img
                          src={!imageFile ? `${Upload}` : URL.createObjectURL(imageFile)}
                          alt="Upload"
                          style={{ width: '100%', zIndex: '10000' }}
                        />
                      )}
                      <button>
                        <input
                          type="file"
                          accept=".jpeg, .jpg"
                          onChange={e => {
                            const file = e.target.files[0];
                            if (file && (file.type === 'image/jpeg' || file.type === 'image/jpg')) {
                              handleInputChangeadduser(rowData.id, 'UserImage', file);
                              setUserImageId(rowData?.attributes?.UserImage?.data?.id);
                            } else {
                              toaster.push(
                                <Message showIcon type="error">
                                  Please select a JPEG or JPG image.
                                </Message>
                              );
                            }
                          }}
                        />
                        <span>1</span>
                      </button>
                    </div>
                  </>
                ) : userImage ? (
                  <img
                    src={`${ip}${userImage}`}
                    alt="User Image"
                    style={{ width: 50, height: 50, marginTop: '-16px' }}
                  />
                ) : (
                  'No image'
                );
              }}
            </Table.Cell>
          </Table.Column>

          <Table.Column width={150} align="center" fullText>
            <Table.HeaderCell>
              <b style={{ fontSize: '14px' }}>Full Name</b>
            </Table.HeaderCell>
            <Table.Cell>
              {rowData =>
                editedRowIds.includes(rowData.id) ? (
                  <Input
                    value={editedData[rowData.id]?.Full_Name || ''}
                    onChange={value => handleInputChangeadduser(rowData.id, 'Full_Name', value)}
                  />
                ) : (
                  rowData.attributes.Full_Name
                )
              }
            </Table.Cell>
          </Table.Column>

          <Table.Column width={150} align="center">
            <Table.HeaderCell>
              <b style={{ fontSize: '14px' }}>Username</b>
            </Table.HeaderCell>
            <Table.Cell>
              {rowData =>
                editedRowIds.includes(rowData.id) ? (
                  <Input
                    value={editedData[rowData.id]?.Username || ''}
                    onChange={value => handleInputChangeadduser(rowData.id, 'Username', value)}
                  />
                ) : (
                  rowData.attributes.Username
                )
              }
            </Table.Cell>
          </Table.Column>
          <Table.Column width={150} align="center" fullText>
            <Table.HeaderCell>
              <b style={{ fontSize: '14px' }}>Password</b>
            </Table.HeaderCell>
            <Table.Cell>
              {rowData =>
                editedRowIds.includes(rowData.id) ? (
                  <InputGroup inside style={styles}>
                    <Input
                      type={visible ? 'text' : 'password'}
                      value={editedData[rowData.id]?.Password || ''}
                      onChange={value => handleInputChangeadduser(rowData.id, 'Password', value)}
                    // size='xs'
                    />
                    <InputGroup.Button onClick={handleChange}>
                      {visible ? <EyeIcon /> : <EyeSlashIcon />}
                    </InputGroup.Button>
                  </InputGroup>
                ) : (
                  <InputGroup inside style={styles}>
                    <Input
                      type="password"
                      value="..." // Display the dots instead of the actual password
                      disabled // Disable the input when not in edit mode
                    />
                    <InputGroup.Button disabled>
                      <EyeSlashIcon /> {/* Or an empty icon to match the disabled input */}
                    </InputGroup.Button>
                  </InputGroup>
                )
              }
            </Table.Cell>
          </Table.Column>
          <Table.Column width={80} align="center">
            <Table.HeaderCell>
              <b style={{ fontSize: '14px' }}>Profile</b>
            </Table.HeaderCell>
            <Cell>
              {rowData =>
                editedRowIds.includes(rowData.id) ? (
                  <SelectPicker
                    data={Category}
                    value={editedData[rowData.id]?.Category || ''}
                    onChange={value => handleInputChangeadduser(rowData.id, 'Category', value)}
                    placement="auto"
                  />
                ) : (
                  rowData.attributes.Category
                )
              }
            </Cell>
          </Table.Column>
          <Table.Column width={100} align="center">
            <Table.HeaderCell>
              <b style={{ fontSize: '14px' }}>Designation</b>
            </Table.HeaderCell>
            <Cell>
              {rowData =>
                editedRowIds.includes(rowData.id) ? (
                  <SelectPicker
                    data={desgindata}
                    value={editedData[rowData.id]?.Designation || ''}
                    onChange={value => handleInputChangeadduser(rowData.id, 'Designation', value)}
                    placement="auto"
                  />
                ) : (
                  rowData.attributes.Designation
                )
              }
            </Cell>
          </Table.Column>
          <Table.Column width={150} align="center" fullText>
            <Table.HeaderCell>
              <b style={{ fontSize: '14px' }}>Email</b>
            </Table.HeaderCell>

            <Table.Cell>
              {rowData =>
                editedRowIds.includes(rowData.id) ? (
                  <Input
                    value={editedData[rowData.id]?.Email_Id || ''}
                    onChange={value => handleInputChangeadduser(rowData.id, 'Email_Id', value)}
                  />
                ) : (
                  rowData.attributes.Email_Id
                )
              }
            </Table.Cell>
          </Table.Column>

          <Table.Column width={120} align="center" fullText>
            <Table.HeaderCell>
              <b style={{ fontSize: '14px' }}>Mobile No.</b>
            </Table.HeaderCell>
            <Table.Cell>
              {rowData =>
                editedRowIds.includes(rowData.id) ? (
                  <InputNumber
                    step={null}
                    value={editedData[rowData.id]?.MobileNo || '0'}
                    onChange={value => handleInputChangeadduser(rowData.id, 'MobileNo', value)}
                  />
                ) : rowData.attributes.MobileNo === '0' ? (
                  '-'
                ) : (
                  rowData.attributes.MobileNo
                )
              }
            </Table.Cell>
          </Table.Column>
          <Table.Column width={120} align="center">
            <Table.HeaderCell>
              <b style={{ fontSize: '14px' }}>Action</b>
            </Table.HeaderCell>

            <Table.Cell style={{ padding: '6px' }}>
              {rowData => (
                // return rowData.attributes.Category == 'Admin' ? (
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "5px" }}>
                  {editedRowIds.includes(rowData.id) ? (
                    <div>
                      <IconButton
                        size="sm"
                        icon={<CheckIcon />}
                        active
                        onClick={() => handleSaveRow(rowData.id)}
                        style={{ marginRight: '5px' }}
                        disabled={
                          !editedData[rowData.id]?.Username ||
                          editedData[rowData.id]?.Username.trim() === '' ||
                          data.some(
                            item =>
                              item.attributes.Username.toLowerCase() ===
                              editedData[rowData.id]?.Username.toLowerCase() &&
                              item.id !== rowData.id
                          )
                        }
                      />
                      <IconButton
                        size="sm"
                        icon={<CloseIcon />}
                        active
                        onClick={() =>
                          setEditedRowIds(prevRowIds => prevRowIds.filter(id => id !== rowData.id))
                        }
                      />
                    </div>
                  ) : (
                    <div>
                      <IconButton
                        size="sm"
                        icon={<EditIcon />}
                        active
                        onClick={() => {
                          handleEditRow(rowData);
                        }}
                      />
                    </div>
                  )}
                  <div>
                    {rowData && !rowData?.attributes?.isUserDiscontinue ?
                      <Popconfirm
                        title="Discontinue User"
                        description="Are you sure you want to discontinue this user?"
                        onConfirm={() => confirm(rowData.id, true)}
                        onCancel={cancel}
                        okText="Yes"
                        cancelText="No"
                      >

                        <Whisper speaker={<Tooltip>Discontinue User</Tooltip>}>
                          <IconButton
                            size="sm"
                            icon={<ReviewPass />}
                            active

                          />
                        </Whisper>
                      </Popconfirm>
                      :
                      <Popconfirm
                        title="Reactivate User"
                        description="Are you sure you want to reactivate this user?"
                        onConfirm={() => confirm(rowData.id, false)}
                        onCancel={cancel}
                        okText="Yes"
                        cancelText="No"
                      >

                        <Whisper speaker={<Tooltip>Reactivate User</Tooltip>}>
                          <IconButton
                            size="sm"
                            icon={<UserChange />}
                            active
                          />
                        </Whisper>
                      </Popconfirm>
                    }
                  </div>
                </div>
                // ) : (
                //   '-'
                // );
              )}
            </Table.Cell>
          </Table.Column>
          <Table.Column width={250} align="center">
            <Table.HeaderCell>
              <b style={{ fontSize: 14 }}>Outside Access</b>
            </Table.HeaderCell>
            <Table.Cell>
              {rowData => {
                // if (rowData.attributes.Category === "Admin") return "—";
                return (
                  <AccessEditor
                    userId={rowData.id}
                    initialAllowMultiple={rowData.attributes.allowMultipleDevices}
                    initialExpiry={rowData.attributes.user_expiry_at}
                    fetchData={fetchData}
                  />
                )
              }}
            </Table.Cell>
          </Table.Column>

          {/* <Table.Column width={220} align="center">
            <Table.HeaderCell>
              <b style={{ fontSize: 14 }}>User Expiry</b>
            </Table.HeaderCell>

            <Table.Cell>
              {rowData => (
                <UserExpiryEditor
                  userId={rowData.id}
                  initialValue={rowData.attributes.user_expiry_at}
                />
              )}
            </Table.Cell>
          </Table.Column>
          <Table.Column width={150} align="center">
            <Table.HeaderCell><b style={{ fontSize: 14 }}>Allow Multiple Devices</b></Table.HeaderCell>

            <Table.Cell>
              {rowData => {
                // if (rowData.attributes.Category === "Admin") return "—";

                return (
                  <AllowMultipleToggle
                    userId={rowData.id}
                    initialValue={rowData.attributes.allowMultipleDevices} // use your existing attribute
                  />
                );
              }}
            </Table.Cell>
          </Table.Column> */}
          {/* <Table.Column width={180} align="center">
            <Table.HeaderCell><b style={{ fontSize: 14 }}>Devices</b></Table.HeaderCell>

            <Table.Cell>
              {rowData => {
                useEffect(() => {
                  loadDevicesForRow(rowData.id);
                }, [rowData.id]);

                if (rowData.attributes.Category === "Admin") return <span style={{ color: "#888" }}>—</span>;

                const rowState = rowDevices[rowData.id] || { devices: [], selectedDevice: null };
                if (!rowState.devices || rowState.devices.length === 0) return <span style={{ color: "#888" }}>—</span>;

                const handleSelect = (val, item) => {
                  setRowDevices(prev => ({
                    ...prev,
                    [rowData.id]: { ...prev[rowData.id], selectedDevice: item.full }
                  }));
                };

                return (
                  <SelectPicker
                    data={rowState.devices.map(d => ({ label: d.deviceLabel || d.deviceId, value: d.id, full: d }))}
                    value={rowState.selectedDevice?.id}
                    placeholder="Select Device"
                    style={{ width: 160 }}
                    cleanable={false}
                    onSelect={handleSelect}
                  />
                );
              }}
            </Table.Cell>
          </Table.Column>
          <Table.Column width={150} align="center">
            <Table.HeaderCell><b style={{ fontSize: 14 }}>Device Actions</b></Table.HeaderCell>

            <Table.Cell>
              {rowData => {
                const [openModal, setOpenModal] = useState(false);
                const [selectedAction, setSelectedAction] = useState(null);

                const rowState = rowDevices[rowData.id];
                const selectedDevice = rowState?.selectedDevice;
                if (!selectedDevice || rowData.attributes.Category === "Admin") return "—";

                const defaultAction = selectedDevice.isAllowed ? "approve" : "reject";

                const handleSelect = (value) => {
                  setSelectedAction(value);
                  setOpenModal(true);
                };

                const handleConfirm = async () => {
                  setOpenModal(false);
                  try {
                    if (selectedAction === "approve") await handleDeviceAction(rowData, selectedDevice.id, "approve");
                    else if (selectedAction === "reject") await handleDeviceAction(rowData, selectedDevice.id, "reject");

                    setRowDevices(prev => ({
                      ...prev,
                      [rowData.id]: {
                        ...prev[rowData.id],
                        selectedDevice: { ...selectedDevice, isAllowed: selectedAction === "approve" }
                      }
                    }));
                  } catch (err) {
                    console.error(err);
                  }
                  setSelectedAction(null);
                };

                return (
                  <>
                    <SelectPicker
                      data={actionOptions}
                      value={defaultAction}
                      onSelect={handleSelect}
                      cleanable={false}
                      style={{ width: 150 }}
                    />

                    <Modal open={openModal} onClose={() => setOpenModal(false)}>
                      <Modal.Header><Modal.Title>Confirm Action</Modal.Title></Modal.Header>
                      <Modal.Body>
                        Are you sure you want to <b>{selectedAction}</b> this device?
                      </Modal.Body>
                      <Modal.Footer>
                        <Button appearance="subtle" onClick={() => setOpenModal(false)}>Cancel</Button>
                        <Button appearance="primary" onClick={handleConfirm}>Confirm</Button>
                      </Modal.Footer>
                    </Modal>
                  </>
                );
              }}
            </Table.Cell>
          </Table.Column> */}

          {/* <Table.Column width={150} align="center">
            <Table.HeaderCell>
              <b style={{ fontSize: '14px' }}>Device Actions</b>
            </Table.HeaderCell>

            <Table.Cell>
              {rowData => {
                const [openModal, setOpenModal] = useState(false);
                const [selectedAction, setSelectedAction] = useState(null);
                const [defaultAction, setDefaultAction] = useState(null);
                useEffect(() => {
                  const fetchDeviceStatus = async () => {
                    try {
                      const res = await fetch(`${globalIP}/api/device-access/user/${rowData.id}`);
                      const data = await res.json();
                      const devices = data.devices || [];

                      if (devices.length > 0) {
                        const anyAllowed = devices.some(d => d.isAllowed);
                        setDefaultAction(anyAllowed ? 'approve' : 'reject');
                      } else {
                        setDefaultAction(null);
                      }
                    } catch (err) {
                      console.error(err);
                    }
                  };
                  fetchDeviceStatus();
                }, [rowData.id]);
                const handleSelect = (value) => {
                  setSelectedAction(value);
                  setOpenModal(true);
                };

                const handleConfirm = async () => {
                  setOpenModal(false);

                  try {
                    if (selectedAction === 'approve') await handleDeviceAction(rowData.id, 'approve');
                    else if (selectedAction === 'reject') await handleDeviceAction(rowData.id, 'reject');
                    else if (selectedAction === 'allow-multi') await handleMultiDeviceAction(rowData.id);

                    // ✅ Update SelectPicker value after API success
                    setDefaultAction(selectedAction);
                  } catch (err) {
                    console.error("Action failed:", err);
                  }

                  setSelectedAction(null);
                };

                const handleCancel = () => {
                  setOpenModal(false);
                  setSelectedAction(null);
                };

                if (rowData.attributes.Category == 'Admin') {
                  return <span style={{ color: "#888" }}>—</span>;
                }

                return (
                  <>
                    <SelectPicker
                      data={actionOptions}
                      labelKey="label"
                      valueKey="value"
                      placeholder="Actions"
                      style={{ width: 150 }}
                      onSelect={handleSelect}
                      value={defaultAction} // <-- Set default value based on device
                      cleanable={false}
                      renderMenuItem={(label, item) => (
                        <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                          {label}
                        </div>
                      )}
                    />

                    <Modal open={openModal} onClose={handleCancel}>
                      <Modal.Header>
                        <Modal.Title>Confirm Action</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        Are you sure you want to <b>{selectedAction === 'allow-multi' ? 'allow multiple devices' : selectedAction}</b> for this user?
                      </Modal.Body>
                      <Modal.Footer>
                        <Button onClick={handleCancel} appearance="subtle">Cancel</Button>
                        <Button onClick={handleConfirm} appearance="primary">Confirm</Button>
                      </Modal.Footer>
                    </Modal>
                  </>
                );
              }}
            </Table.Cell>

          </Table.Column>
          <Table.Column width={150} align="center">
            <Table.HeaderCell>
              <b style={{ fontSize: '14px' }}>Allow Multiple Devices</b>
            </Table.HeaderCell>

            <Table.Cell>
              {rowData => {
                const [allowMultiple, setAllowMultiple] = useState(false);
                const [loading, setLoading] = useState(false);

                // Fetch initial allowMultiple from user devices
                useEffect(() => {
                  const fetchUserDevice = async () => {
                    try {
                      const res = await fetch(`${globalIP}/api/device-access/user/${rowData.id}`);
                      const data = await res.json();
                      const devices = data.devices || [];

                      // If any device has allowMultiple true, set it
                      const anyAllowed = devices.some(d => d.allowMultipleDevices);
                      setAllowMultiple(anyAllowed);
                    } catch (err) {
                      console.error(err);
                    }
                  };
                  fetchUserDevice();
                }, [rowData.id]);

                const handleToggle = async (checked) => {
                  try {
                    setLoading(true);

                    // Find the current device rowId to update
                    const res = await fetch(`${globalIP}/api/device-access/user/${rowData.id}`);
                    const data = await res.json();
                    const devices = data.devices || [];
                    if (devices.length === 0) throw new Error("No devices found");

                    // Here we assume you want to toggle all devices for this user
                    // Or you can choose the first/current device
                    const deviceRowId = devices[0].id;

                    const apiURL = `${globalIP}/api/device-access/${deviceRowId}/allow-multiple-devices`;
                    const response = await fetch(apiURL, {
                      method: "PUT",
                      headers: { "Content-Type": "application/json" },
                      body: JSON.stringify({ allow: checked }),
                    });
                    const resData = await response.json();

                    if (!response.ok) throw new Error(resData?.error?.message || "Update failed");

                    setAllowMultiple(checked);
                    toaster.push(<Message showIcon type="success">{resData.message}</Message>, { placement: 'topCenter' });
                  } catch (err) {
                    console.error(err);
                    toaster.push(<Message showIcon type="error">{err.message}</Message>, { placement: 'topCenter' });
                  } finally {
                    setLoading(false);
                  }
                };
                if (rowData.attributes.Category == 'Admin') {
                  return <span style={{ color: "#888" }}>—</span>;
                }

                return (
                  <Switch
                    size="sm"
                    checked={allowMultiple}
                    onChange={handleToggle}
                    loading={loading}
                  />
                );
              }}
            </Table.Cell>
          </Table.Column> */}
          <Table.Column width={120} align="center">
            <Table.HeaderCell>
              <b style={{ fontSize: '14px' }}>Controls</b>
            </Table.HeaderCell>
            <Table.Cell>
              {rowData => {
                if (rowData.attributes.Category === 'Staff') {
                  return (
                    <Button
                      onClick={() => handleModalOpen(rowData.id)}
                      appearance="subtle"
                      active
                      style={{ color: '#03a9f4' }}
                    >
                      Access
                    </Button>
                  );
                } else {
                  return <p style={{ color: 'green' }}>Full Access</p>;
                }
              }}
            </Table.Cell>
          </Table.Column>
        </Table>

        <Modal size="lg" backdrop="static" open={open} onClose={handleClose}>
          <Modal.Header>
            <Modal.Title>
              <h5>Add User</h5>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form fluid ref={formRef} onChange={setFormValue} formValue={formValue} model={model}>
              <FlexboxGrid justify="space-between">
                <FlexboxGrid.Item as={Col} colspan={24} md={8} style={{ marginBottom: '10px' }}>
                  <Form.Group controlId="name-1">
                    <Form.ControlLabel>
                      <Stack>
                        <p>Full Name</p>
                        <p style={{ color: 'red' }}>*</p>
                      </Stack>
                    </Form.ControlLabel>
                    <Input
                      id="Full_Name"
                      name="Full_Name"
                      value={dataadd && dataadd.Full_Name ? dataadd.Full_Name : ''}
                      onChange={value => handleInputChange('Full_Name', value)}
                    />
                  </Form.Group>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={4}>
                  <Form.Group controlId="name-1">
                    <Form.ControlLabel>
                      <Stack>
                        <p>Profile Category</p>
                        <p style={{ color: 'red' }}>*</p>
                      </Stack>
                    </Form.ControlLabel>
                    <InputPicker
                      block
                      id="Category"
                      name="Category"
                      value={dataadd && dataadd.Category ? dataadd.Category : ''}
                      onChange={value => handleInputChange('Category', value)}
                      data={Category}
                    />
                  </Form.Group>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={4}>
                  <Form.Group controlId="name-1">
                    <Form.ControlLabel>Designation</Form.ControlLabel>
                    <InputPicker
                      block
                      id="Designation"
                      name="Designation"
                      value={dataadd && dataadd.Designation ? dataadd.Designation : ''}
                      onChange={value => handleInputChange('Designation', value)}
                      data={desgindata}
                    />
                  </Form.Group>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={8}>
                  <Form.Group controlId="name-1">
                    <Form.ControlLabel>
                      <Stack>
                        <p>Username</p>
                        <p style={{ color: 'red' }}>*</p>
                      </Stack>
                    </Form.ControlLabel>
                    <Input
                      id="Username"
                      name="Username"
                      value={dataadd && dataadd.Username ? dataadd.Username : ''}
                      onChange={value => handleInputChange('Username', value)}
                    // onBlur={() => checkAliasCodeExistence(dataadd.Username)}
                    />
                  </Form.Group>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={8}>
                  <Form.Group controlId="password-1" style={{ marginBottom: '10px' }}>
                    <Form.ControlLabel>
                      <Stack>
                        <p>Password</p>
                        <p style={{ color: 'red' }}>*</p>
                      </Stack>
                    </Form.ControlLabel>
                    <TextField
                      name="password"
                      type="password"
                      autoComplete="off"
                      id="Password"
                      value={dataadd && dataadd.Password ? dataadd.Password : ''}
                      onChange={value => handleInputChange('Password', value)}
                    />
                  </Form.Group>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={8}>
                  <Form.Group controlId="password-1">
                    <Form.ControlLabel>Confirm Password</Form.ControlLabel>
                    <TextField name="verifyPassword" type="password" autoComplete="off" />
                  </Form.Group>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={8}>
                  <Form.Group controlId="email-1">
                    <Form.ControlLabel>Email</Form.ControlLabel>
                    <Input
                      id="Email_Id"
                      name="Email_Id"
                      value={dataadd && dataadd.Email_Id ? dataadd.Email_Id : ''}
                      onChange={value => handleInputChange('Email_Id', value)}
                    />
                  </Form.Group>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={8}>
                  <Form.Group controlId="name-1">
                    <Form.ControlLabel>Mobile Number</Form.ControlLabel>
                    <InputNumber
                      id="MobileNo"
                      name="MobileNo"
                      value={dataadd && dataadd.MobileNo ? dataadd.MobileNo : '0'}
                      onChange={value => handleInputChange('MobileNo', value)}
                    />
                  </Form.Group>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={8}>
                  <Form.Group controlId="name-1">
                    <Form.ControlLabel>
                      <Stack>
                        <p>Company Name</p>
                        <p style={{ color: 'red' }}>*</p>
                      </Stack>
                    </Form.ControlLabel>
                    <SelectPicker
                      block
                      id="Company_Name"
                      name="Company_Name"
                      value={dataadd && dataadd.Company_Name ? dataadd.Company_Name : ''}
                      onChange={value => handleInputChange('Company_Name', value)}
                      data={data1}
                    />
                  </Form.Group>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={8}>
                  <Form.Group controlId="name-1">
                    <Form.ControlLabel>Add User Image</Form.ControlLabel>
                    <Stack>
                      {/* <Uploader
                        style={{ display: 'flex', gap: '20px' }}
                        active
                        listType="picture-text"
                        accept=".jpeg, .jpg"
                        renderFileInfo={(file, fileElement) => {
                          return (
                            <>
                              <span>File Name: {file.name}</span>
                              <p>File URL: {file.url}</p>
                            </>
                          );
                        }}
                        onChange={handleImageUpload}
                        action={''}
                      >
                        <Button>Upload Image</Button>
                      </Uploader> */}
                      <Button onClick={handleButtonClick} appearance="default" active>
                        <ImageIcon /> Upload Image
                      </Button>
                      <input
                        type="file"
                        ref={fileInputRef}
                        accept=".jpg, .jpeg"
                        onChange={handleFileChange}
                        style={{ display: 'none' }} // Hide the default file input
                      />
                      {dataadd.UserImage && (
                        <img
                          src={imageFile}
                          alt="Uploaded"
                          style={{ width: '36px', height: '36px', marginLeft: '10px' }}
                        />
                      )}
                    </Stack>
                  </Form.Group>
                </FlexboxGrid.Item>
              </FlexboxGrid>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Stack justifyContent="flex-end" spacing={10}>
              <Button onClick={handleClose} appearance="default" active>
                Cancel
              </Button>
              <Button onClick={submit} appearance="primary" color="cyan">
                Save
              </Button>
            </Stack>
          </Modal.Footer>
        </Modal>

        <Modal backdrop="static" role="alertdialog" open={open1} onClose={handleClose1} size="xs">
          <Modal.Body>
            <RemindIcon style={{ color: '#ffb300', fontSize: 24 }} />
            Please fill the all feilds!
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={handleClose1} appearance="subtle" active>
              Cancel
            </Button>
            <Button onClick={handleClose1} appearance="primary" color="cyan">
              OK
            </Button>
          </Modal.Footer>
        </Modal>
        {modalOpen && <YourModal onClose={handleModalClose} data={modalData} />}
        <Stack
          className="copyright"
          justifyContent="flex-end"
          spacing={5}
          style={{
            position: 'fixed',
            bottom: '0',
            width: '-webkit-fill-available',
            textAlign: 'center',
            backgroundColor: 'white',
            paddingRight: '16px'
          }}
        >
          <p>© All Right Reserved. Product by </p>
          <p>
            {' '}
            <a href="https://erpdaddy.com/" target="_blank">
              ERPDaddy Software Solution.
            </a>
          </p>
        </Stack>
      </Container>
    </>
  );
};

export default AddUser;
